export default "__VITE_ASSET__CSbm8UY$__"